import Swiper from "https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs";

document.addEventListener("DOMContentLoaded", (event) => {
    if (!customElements.get('three-images')) {
        class ThreeImages extends HTMLElement {
            constructor() {
                super();
                this.initializeOptions();
                this.init();
            }

            initializeOptions() {
                this.options = {
                    slidesPerView: 1.25,
                    spaceBetween: 4,
                    scrollbar: {
                        el: this.querySelector('.swiper-scrollbar'),
                        draggable: true,
                    },
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                    breakpoints: {
                        700: {
                            slidesPerView: 3,
                            enabled: false
                        }
                    }
                };
            }

            init() {
                this.swiper = new Swiper(this.querySelector('.swiper'), this.options);
            }
        }

        customElements.define('three-images', ThreeImages);
    }
});